import { cx } from '@mage-ui/styled-system/css';
import { shopCardList, text } from '@mage-ui/styled-system/recipes';

export const ShopCardList = ({ data = [], className }) => {
	if (!Array.isArray(data) || data.length === 0) return null;
	return (
		<ul className={className}>
			{data.map(
				(item) =>
					item?.value?.toString().trim() && (
						<li
							key={item.name}
							className={cx(
								shopCardList().root,
								item.summary && shopCardList().summary,
							)}
						>
							<div className={shopCardList().row}>
								<div
									className={cx(
										shopCardList().columnLeft,
										item.summary && shopCardList().summaryName,
									)}
								>
									{item.name}
								</div>
								<div
									className={cx(
										shopCardList().columnRight,
										item.summary && shopCardList().summaryValue,
										item.summary && text({ size: '1' }),
									)}
								>
									<strong>{item.value}</strong>
								</div>
							</div>
						</li>
					),
			)}
		</ul>
	);
};
